import React from 'react'
import { Icon, Card, Tag, Breadcrumb, Empty } from 'antd'
import * as _ from 'lodash'

import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps } from 'react-router'
import ListRender from './components/listRender'

import * as styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {}

// 经传人
class List extends ComponentExt<IProps, IState> {
  state = {
    breadCrumb: [{ linkTo: '/team', text: '经传人' }, { linkTo: '', text: '' }],
    list: [],
    listLen: 0,
    tags: [],
    recommendList: [],
    activityList: [],
    selectedTags: [],
    banner: '',
    intro: '',
    defaultKeys: '',
    defaultRequestParams: {},
  }

  async componentDidMount() {
    const id = this.handleGetSearchParams('labelId')
    const defaultKeys = this.handleGetSearchParams('listType')
    const tagName = this.handleGetSearchParams('tagName')
    const breadCb = [
      { linkTo: '/team', text: '经传人' },
      { linkTo: '', text: tagName },
    ]
    const params = {
      label_type: 2,
      label_id: id,
      type: defaultKeys,
    }
    if (defaultKeys === '0') {
      delete params.type
    }
    this.setState(
      {
        breadCrumb: breadCb,
        selectedTags: [{ id }],
        defaultKeys,
        defaultRequestParams: params,
      },
      () => this.handleRequestList(params),
    )
  }

  // tslint:disable-next-line: variable-name
  handleRequestList = params => {
    this.handleFetchArticleList(params)
    this.handleFetchHotArticleList(params)
    this.handleFetchLabelList(params)
    this.handleFetchActivityList()
    this.handleFetchActivityIntro()
    this.handleFetchActivityBanner()
  }

  async handleFetchArticleList(params: {
    label_type?: number
    label_id?: number
    type?: number
    page?: number
    limit?: number
  }) {
    try {
      const {
        list,
        count: listLen,
      } = await this.api.family.getFamilyArticleList(params)
      this.setState({
        list,
        listLen,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchHotArticleList(params: {
    label_type: number
    type?: number
    limit?: number
  }) {
    try {
      const recommendList = await this.api.family.getFamilyHotArticleList(
        params,
      )
      this.setState({
        recommendList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchLabelList(params: { label_type: number }) {
    try {
      const tags = await this.api.family.getFamilyLabelList(params)
      this.setState({ tags })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityList() {
    try {
      const {
        data: activityList,
      } = await this.api.family.getFamilyActivityList({})
      this.setState({ activityList })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityIntro() {
    try {
      const intro = await this.api.family.getFamilyActivityIntroDuce()
      // console.log('intro', intro)
      this.setState({ intro })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityBanner() {
    try {
      const banner = await this.api.family.getFamilyActivityBanner()
      // console.log('banner', banner)
      this.setState({
        banner: banner[0],
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityDetail(param: { id: number }) {
    try {
      const detail = await this.api.family.getFamilyActivityDetail(param)
      // console.log('detail', detail)
    } catch (err) {
      console.error(err.message)
    }
  }

  handleClickBreadCrumb = link => {
    if (link) {
      this.props.history.push('/team')
    }
  }

  handleSliceString = (str, limit = 30) => {
    let res = str
    if (str && str.length > limit) {
      res = `${str.slice(0, limit)}···`
      return res
    }
    return res
  }

  handleGetSearchParams = type => {
    return new URLSearchParams(this.props.location.search).get(type)
  }

  handleRenderBreadCrumb = () => {
    const { breadCrumb } = this.state
    if (_.isEmpty(breadCrumb)) {
      return
    }
    return (
      <Breadcrumb separator=">">
        {_.map(breadCrumb, (itm, idx) => (
          <Breadcrumb.Item
            onClick={() => this.handleClickBreadCrumb(itm.linkTo)}
            key={idx}
          >
            <a>{itm.text}</a>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    )
  }

  handleClickList = (e, data, type) => {
    const { selectedTags } = this.state
    // 阻止冒泡
    e.stopPropagation()
    const WINOPEN = url => {
      window.open(window.location.origin + url, '_blank')
    }
    if (type === 'li') {
      WINOPEN(`#/team/detail/${type}?id=${data.id}`)
      // this.props.history.push(`/team/detail/${type}?id=${data.id}`)
    } else if (type === 'act') {
      WINOPEN(`#/team/actdetail/act?activityId=${data}`)
      // this.props.history.push(`/team/detail/act?activityId=${data}`)
    } else if (type === 'actBanner') {
      WINOPEN(`#/team/actintro/act?actBanner=${data}`)
      // this.props.history.push(`/team/detail/act?actBanner=${data}`)
    } else if (
      type === 'tag' &&
      Number(selectedTags[0].id) !== Number(data.id * 1)
    ) {
      // this.props.history.push(
      //   `/housework/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      // )
      WINOPEN(
        `#/team/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      )
    }
  }

  handleClickMenu = e => {
    const { defaultRequestParams } = this.state
    const params: any = _.assign({}, defaultRequestParams)
    if (e.key === 'news') {
      delete params.type
    } else {
      params.type = Number(e.key)
      this.setState({ listType: Number(e.key) })
    }
    this.handleRequestList(params)
  }

  handleRenderList = () => {
    const { list } = this.state
    if (_.isEmpty(list)) {
      return (
        <Card>
          <Empty description="暂无数据" />
        </Card>
      )
    }
    return _.map(list, (itm, idx) => (
      <li
        className={itm.type === '1000101' ? styles.vdBg : null}
        onClick={e => this.handleClickList(e, itm, 'li')}
        key={itm.id}
      >
        <div className={styles.listImg}>
          <img
            src={
              itm.img_url ||
              'http://xy-v.jingzhuan.cn/image/dbcc47bdb414b2bb78ac3727ab565e16.png'
            }
            alt=""
          />
        </div>
        <div className={styles.listContent}>
          <h4>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </h4>
          <p style={{ minHeight: '44px' }}>
            {this.handleSliceString(itm.article_desc, 50)}
          </p>
          <span>{itm.author}</span>
          <span>{itm.publish_date.split(' ')[0]}</span>
          {itm.label.length > 0 &&
            _.map(itm.label, item => (
              <span
                onClick={e => this.handleClickList(e, item, 'tag')}
                key={item.id}
                className={styles.listTag}
              >{`#${item.label_name}`}</span>
            ))}
        </div>
      </li>
    ))
  }

  handleRenderTag = () => {
    const { tags, selectedTags } = this.state
    if (_.isEmpty(tags)) {
      return
    }

    return _.map(tags, itm => (
      <Tag
        key={itm.id}
        color={
          _.findIndex(selectedTags, o => o.id * 1 === itm.id) > -1 && '#108ee9'
        }
        onClick={e => this.handleClickList(e, itm, 'tag')}
      >
        {itm.label_name}
      </Tag>
    ))
  }

  handleRenderRecommend = () => {
    const { recommendList } = this.state
    if (_.isEmpty(recommendList)) {
      return
    }
    return _.map(recommendList, (itm, idx) => {
      if (idx === 0) {
        return (
          <div
            className={styles.banner}
            key={itm.id}
            onClick={e => this.handleClickList(e, itm, 'li')}
          >
            <img src={itm.img_url} alt={itm.article_desc} />
            <p>
              {this.handleSliceString(itm.title, 30)}
              {itm.type === '1000101' && <Icon type="play-square" />}
            </p>
          </div>
        )
      }
      return (
        <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
          <p>
            {this.handleSliceString(itm.title, 30)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </p>
        </li>
      )
    })
  }

  handleRenderActivity = () => {
    const {
      activityList,
      banner,
      intro,
    }: { activityList: any; banner: any; intro: string } = this.state
    const len = activityList.length
    if (_.isEmpty(activityList)) {
      return
    }
    return (
      <>
        <div
          className={styles.banner}
          onClick={e => this.handleClickList(e, intro, 'actBanner')}
        >
          <img
            height="145"
            width="224"
            src={banner.img_url}
            alt={banner.remark}
          />
        </div>
        {_.map(activityList, (itm, idx) => (
          <li key={idx} onClick={e => this.handleClickList(e, itm.id, 'act')}>
            {this.handleSliceString(itm.title)}
          </li>
        ))}
      </>
    )
  }

  render() {
    const that = this
    const { listLen, breadCrumb, defaultKeys } = this.state
    const {
      handleClickMenu,
      handleRenderList,
      handleRenderTag,
      handleRenderRecommend,
      handleRenderBreadCrumb,
      handleRenderActivity,
      handleFetchActivityDetail,
    } = this
    const mapListRenderProps: any = {
      that,
      listLen,
      defaultKeys,
      handleClickMenu,
      handleRenderList,
      handleRenderTag,
      handleRenderRecommend,
      handleRenderActivity,
    }
    return (
      <div className={styles.list}>
        <>{handleRenderBreadCrumb()}</>
        <div className={styles.content}>
          <div className={styles.tag}>
            <Icon type="tag" />
            {breadCrumb[1].text}
          </div>
          <ListRender {...mapListRenderProps} />
        </div>
      </div>
    )
  }
}

export default List
